module.exports = __webpack_public_path__ + "static/media/MSW_01.f04a20c3.jpg";